module.exports = __webpack_public_path__ + "img/beneficios.8c072ada.jpg";